import gql from 'graphql-tag';
import HelperGraphql from 'utils/helper-graphql'

const fields = {
	'active': '[String]'
};

export default gql(`
	query email_templates( ${ HelperGraphql.createFields( fields ) } ) {
		email_templates( ${ HelperGraphql.createVariables( fields ) } ) {
			guid
			type
			time
			active
			
			contents {
				subject
				content
				
				language {
					code
				}
			}
		}
	}
`);

